$(document).ready(function ($) {
    
    let formFirstGuideline = $('[data-form-first-guideline]');
    if(formFirstGuideline.length){
        formFirstGuideline.validate();
    }
});


// WEBPACK FOOTER //
// ./components/guideline.js